module.exports = __webpack_public_path__ + "media/audio72.7e8a1f4b.mp3";